<ng-select [items]="values"
			[searchFn]="customSearchFn"
			bindLabel="name"
			[placeholder]="placeholder"
			[(ngModel)]="selected"
			(change)="onChange()"
			[disabled]="disabled"
			[multiple]="multiple"
			[closeOnSelect]="closeOnSelect"
			[searchable]="searchable"
			>
</ng-select>
